import { render, staticRenderFns } from "./forget-password.component.vue?vue&type=template&id=d8b2b654"
import script from "./forget-password.component.ts?vue&type=script&lang=ts&external"
export * from "./forget-password.component.ts?vue&type=script&lang=ts&external"
import style0 from "./forget-password.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports